import type { InteractionType } from '~/model/InteractionType';
import type { ProjectType } from '~/model/ProjectType';
import appConst from '~/const/appConst';

export const checkIsProject = (
  entity: InteractionType | ProjectType,
): entity is ProjectType => {
  return entity?.['@type'] === appConst.entityTypes.project;
};
